<template>
  <mdb-container fluid>
    <mdb-row
      v-if="
        filteredData.regions.length > 0 &&
          filteredData.regions.length != countAllRegions
      "
      class="filtered-list-group "
    >
      <mdb-col lg="2" md="3" sm="4">
        <p class="heading-color title">Regions Filters:</p>
      </mdb-col>

      <mdb-col
        v-for="region of filteredData.regions"
        :key="region"
        col="6"
        lg="1"
        md="2"
        sm="4"
        class="tag col-xs-6"
      >
        <DtCloseablePadge
          @close="closed('regions', region)"
          :label="region"
          color="green"
        />
      </mdb-col>
    </mdb-row>

    <mdb-row
      v-if="
        filteredData.services.length > 0 &&
          filteredData.services.length != countAllServices
      "
      class="filtered-list-group "
    >
      <mdb-col lg="2" md="3" sm="4">
        <p class="heading-color title">Services Filters:</p>
      </mdb-col>
      <mdb-col
        v-for="service of filteredData.services"
        :key="service"
        col="6"
        lg="1"
        md="2"
        sm="4"
        class="tag"
      >
        <DtCloseablePadge
          @close="closed('services', service)"
          :label="service"
          color="green"
        />
      </mdb-col>
    </mdb-row>
    <mdb-row
      v-if="filteredData.operators.length > 0"
      class="filtered-list-group"
    >
      <mdb-col lg="2" md="3" sm="4">
        <p class="heading-color title">Operators Filters:</p>
      </mdb-col>
      <mdb-col
        v-for="operator of filteredData.operators"
        :key="operator"
        col="6"
        lg="1"
        md="2"
        sm="4"
        class="tag"
      >
        <DtCloseablePadge
          @close="closed('operators', operator)"
          :label="operator"
          color="green"
        />
      </mdb-col>
    </mdb-row>

    <mdb-row
      v-if="
        filteredData.countries.length > 0 &&
          filteredData.countries.length != countAllCountries
      "
      class="filtered-list-group country-row"
    >
      <template
        v-if="
          filteredData.countries.length <= 10 ||
            (filteredData.countries.length > 10 && showALlCountries == false)
        "
      >
        <mdb-col lg="2" md="3" sm="4">
          <p class="heading-color title">
            Countries Filters:
          </p>
        </mdb-col>

        <mdb-col
          v-for="country of filteredData.countries.slice(0, 10)"
          :key="country"
          col="6"
          lg="1"
          md="2"
          sm="4"
          class="tag"
        >
          <DtCloseablePadge
            @close="closed('countries', country)"
            :label="getCountryName(country)"
            color="green"
          />
        </mdb-col>
        <mdb-col col="12">
          <button
            v-if="filteredData.countries.length > 10"
            class="show-less-more"
            @click="showALlCountries = true"
          >
            <i class="fas fa-chevron-down"></i>
          </button>
        </mdb-col>
      </template>

      <template v-else>
        <mdb-col lg="2" md="3" sm="4">
          <p class="heading-color title">Countries Filters:</p>
        </mdb-col>
        <mdb-row class="no-gutters filtered-list-group ">
          <mdb-col
            v-for="country of filteredData.countries"
            :key="country"
            col="6"
            lg="1"
            md="2"
            sm="4"
            class="tag"
          >
            <DtCloseablePadge
              @close="closed('countries', country)"
              :label="getCountryName(country)"
              color="green"
            />
          </mdb-col>
          <mdb-col col="12">
            <button class="show-less-more" @click="showALlCountries = false">
              <i class="fas fa-chevron-up"></i></button
          ></mdb-col>
        </mdb-row>
      </template>
    </mdb-row>
  </mdb-container>
</template>

<script>
import DtCloseablePadge from "./DtCloseablePadge.vue";
import { applyFilter } from "../common/utilities/mapController.js";
import {
  getCountries,
  getServices,
  getRegions
} from "../common/dataSourceIntegrationService.js";
import { ISO_CODE3 } from "../common/constants.js";
export default {
  name: "FilteredItemsList",
  props: {},
  data() {
    return {
      filteredData: this.$store.getters.mapFilters,
      countAllRegions: 0,
      countAllCountries: 0,
      countAllServices: 0,
      showALlCountries: false
    };
  },
  created() {
    this.countAllCountries = getCountries().length;
    this.countAllServices = getServices().length;
    this.countAllRegions = getRegions().length;
  },
  methods: {
    closed(filterName, item) {
      this.filteredData[filterName].splice(
        this.filteredData[filterName].indexOf(item),
        1
      );
      applyFilter(this.filteredData);
      this.$emit("changed");
    },
    getCountryName(country) {
      let countryName = country;
      if (ISO_CODE3[country] != undefined) {
        countryName = ISO_CODE3[country];
      }

      return countryName;
    }
  },
  components: { DtCloseablePadge }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only  -->
<style lang="scss">
.filtered-list-group {
  padding: 10px 20px 5px;
}
.filtered-list-group:first-child {
  margin-top: 10px;
}
.filtered-list-group:last-child {
  margin-bottom: 10px;
}
.filtered-list-group p {
  margin: 0;
  font-weight: normal;
  text-align: left;
  color: #777;
  width: 130px;
}
.title {
  font-weight: bold;
  font-size: 1rem;
}
.show-less-more {
  color: #5586ab;
  background: transparent;
  border: none;
  font-size: 24px;
  position: relative;
  top: 15px;
  &:hover {
    opacity: 0.75;
  }
  &:active {
    outline: none;
  }
}
.country-row {
  position: relative;
}
span.badge {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #777 !important;
  background: #fff !important;
  font-weight: 500;
  line-height: 1.33;
  box-shadow: 0 1px 3px #bdc9d1;
}
span.badge .close {
  bottom: 21%;
  color: #5586ab !important;
  font-weight: normal;
  opacity: 0.8;
  font-size: 1rem;
  right: 10px;
  font-family: Verdana;
}
span.badge .close:hover {
  opacity: 1 !important;
}
.tag,
.tag > div {
  padding-left: 0;
  padding-right: 5px;
}
</style>
